/** @format */

import React from 'react';

import PropTypes from 'prop-types';
import {Autocomplete} from '@sttark/design-system';

import useSizeAutocomplete, {sortByNumericDistance} from './hooks/use_size_autocomplete';
import {ConditionalButton} from 'frontier-utilities';

export default function SizeSelect({
    width,
    onWidthChange,
    length,
    onLengthChange,
    depth,
    onDepthChange,
    dies,
    errors,
    onBlurFunc
}) {
    const {filteredWidths, filteredLengths, filteredDepths} = useSizeAutocomplete(
        dies,
        width,
        length,
        depth
    );

    const widthError = errors.find(e => e.category === 'width');
    const lengthError = errors.find(e => e.category === 'length');
    const depthError = errors.find(e => e.category === 'depth');

    const showDepth = onDepthChange != null;

    return (
        <div className="hstack align-items-baseline">
            <ConditionalButton enabled={showDepth}>
                <>
                    <div className="w-100" onBlur={onBlurFunc}>
                        <Autocomplete
                            type="number"
                            suffix='"'
                            label="Length"
                            name="length"
                            suggestedText="Suggested Lengths"
                            noResultsText={false}
                            data={lengthError ? [] : filteredLengths}
                            displayFn={n => n + '"'}
                            value={length > 0 ? length : ''}
                            onChange={onLengthChange}
                            error={lengthError?.message}
                            filter={sortByNumericDistance}
                        />
                    </div>
                    <p className="mx-4">by</p>
                    <div className="w-100" onBlur={onBlurFunc}>
                        <Autocomplete
                            type="number"
                            suffix='"'
                            label="Width"
                            name="width"
                            suggestedText="Suggested Widths"
                            noResultsText={false}
                            data={widthError ? [] : filteredWidths}
                            displayFn={n => n + '"'}
                            value={width > 0 ? width : ''}
                            onChange={onWidthChange}
                            error={widthError?.message}
                            filter={sortByNumericDistance}
                        />
                    </div>
                    <p className="mx-4">by</p>
                    <div className="w-100">
                        <Autocomplete
                            type="number"
                            suffix='"'
                            label="Depth"
                            name="depth"
                            suggestedText="Suggested Depths"
                            noResultsText={false}
                            data={depthError ? [] : filteredDepths}
                            displayFn={n => n + '"'}
                            value={depth > 0 ? depth : ''}
                            onChange={onDepthChange}
                            error={depthError?.message}
                            filter={sortByNumericDistance}
                        />
                    </div>
                </>
                <>
                    <div className="w-100" onBlur={onBlurFunc}>
                        <Autocomplete
                            type="number"
                            suffix='"'
                            label="Width"
                            name="width"
                            suggestedText="Suggested Widths"
                            noResultsText={false}
                            data={widthError ? [] : filteredWidths}
                            displayFn={n => n + '"'}
                            value={width > 0 ? width : ''}
                            onChange={onWidthChange}
                            error={widthError?.message}
                            filter={sortByNumericDistance}
                        />
                    </div>
                    <p className="mx-4">by</p>
                    <div className="w-100" onBlur={onBlurFunc}>
                        <Autocomplete
                            type="number"
                            suffix='"'
                            label="Length"
                            name="length"
                            suggestedText="Suggested Lengths"
                            noResultsText={false}
                            data={lengthError ? [] : filteredLengths}
                            displayFn={n => n + '"'}
                            value={length > 0 ? length : ''}
                            onChange={onLengthChange}
                            error={lengthError?.message}
                            filter={sortByNumericDistance}
                        />
                    </div>
                </>
            </ConditionalButton>
        </div>
    );
}

SizeSelect.propTypes = {
    dies: PropTypes.arrayOf(
        PropTypes.shape({
            width: PropTypes.number.isRequired,
            length: PropTypes.number.isRequired
        })
    ),
    length: PropTypes.any,
    onLengthChange: PropTypes.func,
    width: PropTypes.any,
    onWidthChange: PropTypes.func,
    depth: PropTypes.any,
    onDepthChange: PropTypes.func,
    errors: PropTypes.array,
    onBlurFunc: PropTypes.func
};
